import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, Inject, NgModule, Injectable } from '@angular/core';
import * as i1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i2 from '@azavista/components/shared';
import { AzavistaSharedModule } from '@azavista/components/shared';
import * as i4$1 from '@azavista/components/button';
import { AzavistaButtonModule } from '@azavista/components/button';
import * as i4 from '@azavista/components/input-field';
import { AzavistaInputFieldModule } from '@azavista/components/input-field';
import * as i5 from '@azavista/components/selected-items-count';
import { AzavistaSelectedItemsCountModule } from '@azavista/components/selected-items-count';
import * as i2$1 from '@angular/common';
import * as i3 from '@ngx-translate/core';

const SELECT_FIELDS = [
    'select',
    'multi-select',
    'from-multi-select',
    'virtual-relation',
    'virtual-object_enum',
];
const TEXT_FIELDS = [
    'text',
    'virtual-textarea',
];
class AzavistaUpdateFieldValueComponent {
    constructor(sharedSvc) {
        this.sharedSvc = sharedSvc;
        this.valueSet = new EventEmitter();
        this.valueFieldEditMode = false;
    }
    ngOnInit() {
        this.data.fields = this.data.fields.map((field) => {
            // ...field,
            // editable: true, mandatory_for_planners: true
            let mandatory = true;
            const fieldType = this.sharedSvc.getFieldTypeFromField(field);
            if ([
                ...TEXT_FIELDS,
                ...SELECT_FIELDS,
                ...this.data.nonRequiredFieldTypes ?? []
            ].includes(fieldType)) {
                mandatory = false;
            }
            const clonedField = { ...field, editable: true, mandatory_for_planners: mandatory };
            return clonedField;
        });
        let usedFieldIds = null;
        if (this.data.selectedField?.id) {
            usedFieldIds = [this.data.selectedField.id];
        }
        this.availableFields = this.sharedSvc.getVisibleAndUsedFields(this.data.fields, usedFieldIds);
        this.fieldSelectField = {
            id: 'field_selector', name: 'field_selector', editable: true, builtin: false, category: '',
            label: '', schema: { type: 'object' }, component: "object_enum" /* FieldComponentType.objectEnum */
        };
        this.fieldSelectFieldValue = {
            items: this.availableFields,
            selected: this.data.selectedField || null,
            displayProperty: 'label'
        };
    }
    getFieldOptions(fieldId) {
        return this.sharedSvc.getFieldOptions(fieldId, this.data.fieldsOptions);
    }
    selectedFieldChanged(change) {
        // We need to recreate the field so put it to null in order for the *niIf to remove the field
        // and set it inside setTimeout later so it will be recreated clean without keeping its previous state
        this.data.selectedField = null;
        this.valueFieldEditMode = true;
        window.setTimeout(() => {
            const selectedField = change.value;
            this.data.selectedField = selectedField;
            const fieldType = this.sharedSvc.getFieldTypeFromField(selectedField);
            if (fieldType === 'boolean') {
                // Simulate false value selected
                const changedArgs = { field: selectedField, value: false };
                this.data.selectedValue = changedArgs;
                this.valueSet.next(changedArgs);
            }
            else if (fieldType === 'select' && selectedField.schema.enum?.includes('')) {
                // Select field that includes an empty value which in the enum appears as an empty string item
                const changedArgs = { field: selectedField, value: '' };
                this.data.selectedValue = changedArgs;
                this.valueSet.next(changedArgs);
            }
            else {
                // Each field change should be treated as no value selected
                this.setValueNotProvided();
            }
        });
    }
    onValueChanged(value) {
        this.data.selectedValue = value;
        this.valueSet.next(value);
    }
    onInvalidValueSet(value) {
        this.setValueNotProvided();
    }
    setValueNotProvided() {
        this.data.selectedValue = null;
        this.valueSet.next(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaUpdateFieldValueComponent, deps: [{ token: i2.AzavistaSharedService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.10", type: AzavistaUpdateFieldValueComponent, selector: "azavista-update-field", inputs: { data: "data" }, outputs: { valueSet: "valueSet" }, ngImport: i0, template: "<div class=\"container azavista-update-field-component aza-cmp-two-columns-grid\">\r\n    <div class=\"field-label\">\r\n        <span translate>UPDATE_THIS_FIELD</span>\r\n    </div>\r\n\r\n    <azavista-input-field\r\n        [field]=\"fieldSelectField\"\r\n        [value]=\"fieldSelectFieldValue\"\r\n        [editMode]=\"true\"\r\n        [fullWidth]=\"true\"\r\n        (valueChanged)=\"selectedFieldChanged($event)\"\r\n        class=\"aza-cmp-medium-width\"\r\n    ></azavista-input-field>\r\n\r\n    <div class=\"value-label\">\r\n        <span translate>TO_THIS_VALUE</span>\r\n    </div>\r\n    <azavista-input-field\r\n        *ngIf=\"data.selectedField\"\r\n        [field]=\"data.selectedField\"\r\n        [editMode]=\"valueFieldEditMode\"\r\n        [canEdit]=\"true\"\r\n        [options]=\"getFieldOptions(data.selectedField.id)\"\r\n        [fullWidth]=\"true\"\r\n        (valueChanged)=\"onValueChanged($event)\"\r\n        (invalidValueSet)=\"onInvalidValueSet($event)\"\r\n        class=\"aza-cmp-medium-width\"\r\n    ></azavista-input-field>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "component", type: i4.AzavistaInputFieldComponent, selector: "azavista-input-field", inputs: ["value", "label", "showLabelForBooleans", "showLabelInReadonlyMode", "field", "locale", "dateTimeDisplayFormat", "dateDisplayFormat", "timeDisplayFormat", "canEdit", "tag", "editMode", "fullWidth", "resetValue", "setImageFieldData", "setDocumentFieldData", "setTextFieldValue", "textAreaOptions", "options", "reportErrorOnInit", "fieldAppearance", "floatLabel", "canBeRequiredAndEmpty", "readonlyMode", "autocompleteAttributeValue", "prefixedValueCssName", "setDefaultValueOnEdit", "alwaysDisplayAsOneLiner", "isTouched", "imgFieldSrc", "layoutDensity"], outputs: ["valueChanged", "invalidValueSet", "relationSearchTextChanged", "autocompleteSearchTextChanged", "editModeEntered", "croppedImageUploaded", "documentSelected"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaUpdateFieldValueComponent, decorators: [{
            type: Component,
            args: [{ selector: 'azavista-update-field', template: "<div class=\"container azavista-update-field-component aza-cmp-two-columns-grid\">\r\n    <div class=\"field-label\">\r\n        <span translate>UPDATE_THIS_FIELD</span>\r\n    </div>\r\n\r\n    <azavista-input-field\r\n        [field]=\"fieldSelectField\"\r\n        [value]=\"fieldSelectFieldValue\"\r\n        [editMode]=\"true\"\r\n        [fullWidth]=\"true\"\r\n        (valueChanged)=\"selectedFieldChanged($event)\"\r\n        class=\"aza-cmp-medium-width\"\r\n    ></azavista-input-field>\r\n\r\n    <div class=\"value-label\">\r\n        <span translate>TO_THIS_VALUE</span>\r\n    </div>\r\n    <azavista-input-field\r\n        *ngIf=\"data.selectedField\"\r\n        [field]=\"data.selectedField\"\r\n        [editMode]=\"valueFieldEditMode\"\r\n        [canEdit]=\"true\"\r\n        [options]=\"getFieldOptions(data.selectedField.id)\"\r\n        [fullWidth]=\"true\"\r\n        (valueChanged)=\"onValueChanged($event)\"\r\n        (invalidValueSet)=\"onInvalidValueSet($event)\"\r\n        class=\"aza-cmp-medium-width\"\r\n    ></azavista-input-field>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i2.AzavistaSharedService }]; }, propDecorators: { data: [{
                type: Input
            }], valueSet: [{
                type: Output
            }] } });

const DEFAULT_EMPTY_VALUES = {
    text: '',
    'virtual-textarea': '',
    boolean: false,
    'multi-select': [],
    'from-multi-select': [],
};
class AzavistaUpdateFieldValueDialogComponent {
    constructor(dialogRef, data, sharedSvc) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.sharedSvc = sharedSvc;
        this.canProceed = false;
    }
    onValueSet(value) {
        if (this.getDefaultEmptyValue() != undefined) {
            this.canProceed = true;
        }
        else if (value === null || value === undefined) {
            this.canProceed = false;
        }
        else {
            this.canProceed = true;
        }
    }
    onCancelClick() {
        this.dialogRef.close();
    }
    onApplyClick() {
        const value = this.data.selectedValue;
        if (value === null || value === undefined) {
            const formattedEmptyValue = {
                field: this.data.selectedField,
                value: this.getDefaultEmptyValue(),
                inputValue: value,
            };
            this.data.selectedValue = formattedEmptyValue;
        }
        ;
        this.dialogRef.close(this.data);
    }
    getDefaultEmptyValue() {
        const fieldType = this.sharedSvc.getFieldTypeFromField(this.data.selectedField);
        return DEFAULT_EMPTY_VALUES[fieldType];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaUpdateFieldValueDialogComponent, deps: [{ token: i1.MatDialogRef }, { token: MAT_DIALOG_DATA }, { token: i2.AzavistaSharedService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.10", type: AzavistaUpdateFieldValueDialogComponent, selector: "ng-component", ngImport: i0, template: "<h1 mat-dialog-title class=\"aza-cmp-dialog-title\"><span translate>UPDATE_FIELD_VALUE</span></h1>\r\n<div mat-dialog-content class=\"field-value-selection aza-cmp-dialog-content\">\r\n    <azavista-selected-items-count [data]=\"data.selectedItemsCountData\"></azavista-selected-items-count>\r\n    <p translate>FOR_ALL_SELECTED_ITEMS</p>\r\n    <azavista-update-field (valueSet)=\"onValueSet($event)\" [data]=\"data\"></azavista-update-field>\r\n</div>\r\n<div mat-dialog-actions class=\"aza-cmp-dialog-actions\">\r\n    <azavista-flat-button (click)=\"onCancelClick()\" color=\"primary\" class=\"aza-cmp-dialog-action-cancel-button\">\r\n        <span>{{\"CANCEL\" | translate | uppercase}}</span>\r\n    </azavista-flat-button>\r\n    <azavista-button [disabled]=\"!canProceed\" (click)=\"onApplyClick()\" color=\"primary\" class=\"aza-cmp-dialog-action-apply-button\">\r\n        <span>{{\"APPLY\" | translate | uppercase}}</span>\r\n    </azavista-button>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "directive", type: i3.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "component", type: i4$1.AzavistaButtonComponent, selector: "azavista-button", inputs: ["acl", "disabled", "cssClasses", "containerCssClasses", "buttonAttributes"] }, { kind: "component", type: i4$1.AzavistaFlatButtonComponent, selector: "azavista-flat-button" }, { kind: "component", type: i5.AzavistaSelectedItemsCountComponent, selector: "azavista-selected-items-count", inputs: ["data"] }, { kind: "component", type: AzavistaUpdateFieldValueComponent, selector: "azavista-update-field", inputs: ["data"], outputs: ["valueSet"] }, { kind: "pipe", type: i2$1.UpperCasePipe, name: "uppercase" }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaUpdateFieldValueDialogComponent, decorators: [{
            type: Component,
            args: [{ template: "<h1 mat-dialog-title class=\"aza-cmp-dialog-title\"><span translate>UPDATE_FIELD_VALUE</span></h1>\r\n<div mat-dialog-content class=\"field-value-selection aza-cmp-dialog-content\">\r\n    <azavista-selected-items-count [data]=\"data.selectedItemsCountData\"></azavista-selected-items-count>\r\n    <p translate>FOR_ALL_SELECTED_ITEMS</p>\r\n    <azavista-update-field (valueSet)=\"onValueSet($event)\" [data]=\"data\"></azavista-update-field>\r\n</div>\r\n<div mat-dialog-actions class=\"aza-cmp-dialog-actions\">\r\n    <azavista-flat-button (click)=\"onCancelClick()\" color=\"primary\" class=\"aza-cmp-dialog-action-cancel-button\">\r\n        <span>{{\"CANCEL\" | translate | uppercase}}</span>\r\n    </azavista-flat-button>\r\n    <azavista-button [disabled]=\"!canProceed\" (click)=\"onApplyClick()\" color=\"primary\" class=\"aza-cmp-dialog-action-apply-button\">\r\n        <span>{{\"APPLY\" | translate | uppercase}}</span>\r\n    </azavista-button>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i2.AzavistaSharedService }]; } });

class AzavistaUpdateFieldValueModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaUpdateFieldValueModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.10", ngImport: i0, type: AzavistaUpdateFieldValueModule, declarations: [AzavistaUpdateFieldValueComponent, AzavistaUpdateFieldValueDialogComponent], imports: [MatDialogModule, MatInputModule, MatSelectModule, MatFormFieldModule, AzavistaSharedModule,
            AzavistaButtonModule, AzavistaInputFieldModule, AzavistaSelectedItemsCountModule], exports: [AzavistaUpdateFieldValueComponent, AzavistaUpdateFieldValueDialogComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaUpdateFieldValueModule, imports: [MatDialogModule, MatInputModule, MatSelectModule, MatFormFieldModule, AzavistaSharedModule,
            AzavistaButtonModule, AzavistaInputFieldModule, AzavistaSelectedItemsCountModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaUpdateFieldValueModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AzavistaUpdateFieldValueComponent, AzavistaUpdateFieldValueDialogComponent],
                    imports: [
                        MatDialogModule, MatInputModule, MatSelectModule, MatFormFieldModule, AzavistaSharedModule,
                        AzavistaButtonModule, AzavistaInputFieldModule, AzavistaSelectedItemsCountModule
                    ],
                    exports: [AzavistaUpdateFieldValueComponent, AzavistaUpdateFieldValueDialogComponent]
                }]
        }] });

class AzavistaUpdateFieldValueService {
    constructor(matDialog, sharedSvc) {
        this.matDialog = matDialog;
        this.sharedSvc = sharedSvc;
    }
    showUpdateFieldDialog(data) {
        // let resolve: (value?: IUpdateFieldData | PromiseLike<IUpdateFieldData>) => void;
        // let reject: (reason?: any) => void;
        // const promise = new Promise<IUpdateFieldData>((res, rej) => {
        //     resolve = res;
        //     reject = rej;
        // });
        const promise = this.matDialog.open(AzavistaUpdateFieldValueDialogComponent, {
            data: data
        }).afterClosed().toPromise(); // .subscribe({
        //     next: (dialogResult: IUpdateFieldData) => {
        //         resolve(dialogResult);
        //     }
        // });
        return promise;
    }
    getFieldValues(field) {
        let result = [];
        const fieldType = this.sharedSvc.getFieldTypeFromField(field);
        if (fieldType === 'select') {
            result = [...field.schema.enum];
        }
        else if (fieldType === 'multi-select') {
            result = [...field.schema.items.enum];
        }
        return result;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaUpdateFieldValueService, deps: [{ token: i1.MatDialog }, { token: i2.AzavistaSharedService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaUpdateFieldValueService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaUpdateFieldValueService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.MatDialog }, { type: i2.AzavistaSharedService }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { AzavistaUpdateFieldValueComponent, AzavistaUpdateFieldValueDialogComponent, AzavistaUpdateFieldValueModule, AzavistaUpdateFieldValueService, DEFAULT_EMPTY_VALUES, SELECT_FIELDS, TEXT_FIELDS };
